export default {
    bindings: {
        getSuggestions: '&',
        items: '=?',
        item: '=?',
        upgrade: '<',
        parent: '<',
        guests: '<?',
        guest: '<?'
    },
    controller: 'displaySuggestionsUpgradeController',
    template: require('../views/display.suggestions.upgrade.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/components/display.suggestions.upgrade.component.js